<template>
  <div class="content" :class="{'autoHeight':isShowMenu}">
    <Header  @showMenu="showMenuEvent"></Header>
    <div class="home-content">
      <div class="home-page por">
        <div class="ac fw7" style="font-size: 40px;margin-top: -70px;text-shadow: 4px 4px 0 #001d8c;">
          <span class="">{{ $t('GrabGet') }}</span>
        </div>
        <div class="tips mt30 ac" style="font-size: 26px;height: 40px;" v-html="$t('home_prize_tip')"></div>
<!--        <div class="scrollLight font-family">-->
<!--          <div class="scroll-wrapper">-->
<!--            <div-->
<!--              class="scroll-item"-->
<!--              v-for="(item, index) in scrollLightData"-->
<!--              :key="index"-->
<!--            >-->
<!--              {{ item }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="disflex mt30" style="justify-content: space-between;padding: 20px 24px;">
          <div>
            <div class="index-img por" @click="goGameList()">
              <img :src="isEN=='bur'?'../../static/images/Mini-Games.jpg':'../../static/images/Mini-Games.jpg'">
              <button class="btn btn-blue1 btn-buttons">
                <div>{{ $t('Play') }} ></div>
              </button>
            </div>
            <div class="index-img por" @click="getRuleTask('cards')">
              <img :src="isEN=='bur'?'../../static/images/Card-BG.jpg':'../../static/images/Card-BG.jpg'">
              <button class="btn btn-blue1 btn-buttons">
                <div>{{ $t('goGet') }} ></div>
              </button>
            </div>
          </div>
          <div>
            <div class="index-bg disflex">
              <img width="80" src="../../static/images/Game.png">
              <div class="index-bg-font">
                <strong>{{$t('chance')}}</strong>
                {{ game_num }} {{$t('chance')}}
              </div>
            </div>
            <div class="index-bg disflex">
              <img width="80" src="../../static/images/Time.png">
              <div class="index-bg-font">
                <strong>{{$t('Free Time')}}</strong>
                <div class="" style="color: #ffdb00;" v-if="miao>0">{{ formatTime(miao) }}</div>
              </div>
            </div>
<!--            <div class="index-bg index-bg2 disflex" @click="showBuyPopup()">-->
<!--              <img width="80" src="../../static/images/buy-more.png">-->
<!--              <div class="index-bg-font">-->
<!--                <strong>{{$t('indexbutton3')}}</strong>-->
<!--              </div>-->
<!--            </div>-->
            <div class="index-img por" @click="getRuleTask('DailyLogin')">
              <div class="index-img-font">{{$t('DailyLogin')}}</div>
              <img :src="isEN=='bur'?'../../static/images/Daily-Login.jpg':'../../static/images/Daily-Login.jpg'">
            </div>
          </div>
        </div>
        <div class="ac disflex mt10 fw7" style="justify-content: space-evenly;">
          <button class="btn-idx" style="font-size: 30px;width: 45%;height: 98px;" @click="getRuleTask('rank')">
            <div class="disflex"><img class="por" width="80" src="../../static/images/rank-icon.png"><span>{{ $t('Ranking') }} ></span></div>
          </button>
          <button class="btn-idx" style="font-size: 30px;width: 45%;height: 98px;" >
           <div class="disflex"><img class="por" width="80" src="../../static/images/star-icon.png" /> <span>{{ $t('Stars') }}:{{ draw_num }}</span></div>
          </button>
        </div>
      </div>
    </div>
    <div class="modal defModal" v-if="isShow">
      <div class="modal-bg" style="background: rgba(0,0,0,.2);"></div>
      <div class="modal-content" style="width: 100%;margin-left: -50%;">
        <div class="modal-content2">
          <img width="" src="../../static/images/prize.gif"/>
        </div>
      </div>
    </div>
    <!-- 邀请成功弹窗-->
    <Dialog ref="subscribeDialog" type="alert" :callback="getSubmit" title="Reminder" width="100" :modalFoot="false" :btnText="$t('OK')" :cancelText="$t('OK')">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <div class="pt20 ac" style="padding-top:10px;font-weight: 700;">
            {{ $t('alertTips') }}
          </div>
          <img style="width: 80%; margin: 30px 0 -10px;" src="../../static/images/robot-img.png">
          <div class="" style="margin: 40px 10px 0;font-size: 24px;">
            <div style="font-size:40px">{{$t('Invitation successful!')}}</div>
               <div class="" style="width: 70%;margin: 10px auto 30px;">{{$t('invitTips1')}}</div>
          </div>
          <button class="btn-yl" @click="getSubmit">{{ $t('OK') }}</button>
        </div>
      </div>
    </Dialog>
    <!-- 购买确认弹窗-->
    <Dialog ref="buyDialog" type="alert" :callback="getBuy" title="Reminder" width="100" :modalFoot="false">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <div class="pt20 ac" style="padding-top:10px;font-weight: 700;">
            {{ $t('buy_popup_tip1') }}
          </div>
          <img style="width: 80%; margin: 30px 0 -10px;" src="../../static/images/robot-img.png">
          <div class="" style="margin-top: 120px;font-size: 24px;">
            <div class="" style="width: 70%;margin: 10px auto 30px;">{{$t('buy_popup_tip2')}}</div>
          </div>
          <button class="btn6 font-family mt20" style="width: 280px;line-height: 103px;color: #fff;font-size: 30px;" @click="closeBuyPopup">{{$t('cancel')}}</button>
          <button style="width: 280px;height: 104px;" class="btn-yl font-family mt20" @click="getBuy()">{{$t('buyNow')}}</button>
        </div>
      </div>
    </Dialog>
    <!--    winer弹窗-->
    <div class="modal login-modal" v-if="isShow3">
      <div class="modal-bg"></div>
      <div class="modal-content modal-content2">
        <img :src="popupImage"/>
        <div class="close ac app-en" @click="getClose">x</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../components/headerNo'
import Footer from '../components/footer'
import Dialog from '../components/dialog'
import DailyLogin from '../components/dailyLogin'

export default {
  components: {
    Header, Dialog, Footer, DailyLogin
  },
  data() {
    return {
      info: {},
      user_id: 0,
      isShow: false,
      isShow2: false,
      isShow3: false,
      keywords: '',
      notFound: false,
      indexImg: [],
      clickIndex: '',
      modalList: {
        'list': [],
      },
      draw_num: '',
      game_num: '',
      answerT: '',
      isEN: 'bur',
      popupImage: null,
      isShowMenu: false,
      miao: null,
      activeTab:1,
      //走马灯
      scrollLightData:{}

    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
    // this.scrollLight();
    //弹窗
    // if (!localStorage.getItem('setTime_v1') || (localStorage.getItem('setTime_v1') &&
    //   Date.parse(new Date()) - localStorage.getItem('setTime_v1') >= 86400000)) {//86400000 24h
    //   localStorage.removeItem('setTime_v1');
    //   localStorage.setItem('setTime_v1', Date.parse(new Date()));
    //   this.getPopup();
    // }
    this.isEN = localStorage.getItem('lang')?localStorage.getItem('lang'):"bur";
  },
  methods: {
    handleChildData() {
      this.getHome();
    },
    // 计时
    countDown(miao, type) {
      if (miao === 0) {
        // this.codeText = this.$t('getCode');
        return;
      }
      miao--;
      this.miao = miao;
      setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
    closeDailyModal() {
      this.$refs.dailyDialog.closeMask()
    },
    showMenuEvent(event) {
      console.log(event)
      this.isShowMenu = event
    },
    getRuleTask(url) {
      this.$router.push({path: '/'+url});
    },
    goGameList() {
      this.$router.push({path: '/gameList',query:{user_id:this.user_id}});
    },
    getHome() {
      let that = this
      that.$api.post('/api/index/index', null, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          if (r.data.alert.length > 0) {
            that.$refs.subscribeDialog.showMaskFun();
          }
          that.user_id = r.data.user_id
          that.indexImg = r.data
          that.game_num = r.data.game_num
          that.question = r.data.question
          that.draw_num = r.data.score
          that.miao = r.data.unlimit_game_second
          that.countDown(that.miao, '')
        })
      })
    },
    tabClick(index){
      this.activeTab = index
    },
    getSubmit() {
      this.$refs.subscribeDialog.closeMask();
    },
    getBuy() {
      let that = this
      let data = {}
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 80);
          that.getHome();
        })
      })
    },
    fastLogin() {
      let that = this
      that.$parent.loadModal(true);
      let data = {
        'mobile': this.$route.query.mobile
      }
      that.$api.post('/api/user/fast_login', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          this.getHome();
        } else {
          that.$utils.alertText(r.msg, 80);
          this.$router.push({path: 'land'})
        }
      })
    },
    getClose() {
      this.isShow3 = false
    },
    getPopup() {
      let that = this
      let data = {}
      that.$api.post('/api/index/popup_image', data, r => {
        that.$parent.returnCode(r, function () {
          that.popupImage = r.data.image
          if (that.popupImage !== null) {
            that.isShow3 = true
          }
        })
      })
    },
    formatTime(seconds) {
      const hrs = Math.floor(seconds / 3600);
      const min = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
      const sec = (seconds % 60).toString().padStart(2, '0');

      if (hrs > 0) {
        return `${hrs.toString().padStart(2, '0')}:${min}:${sec}`;
      } else {
        return `${min}:${sec}`;
      }
    },
    showBuyPopup(){
      this.$refs.buyDialog.showMaskFun();
    },
    closeBuyPopup(){
      this.$refs.buyDialog.closeMask();
    },
    scrollLight(){
      let that = this
      let data = {
      }
      that.$api.post('/api/index/scroll_light',data,r =>{
        that.$parent.returnCode(r,function(){
          that.scrollLightData = r.data
        })
      })
    },
  }
}
</script>
<style scoped>
.bgfff {
  background: #fff !important;
}

.invited-c {
  background: url(../../static/images/invited-bg.jpg) no-repeat center top;
  color: #fff;
  padding: 40px;
  margin: 0 auto;
  border-radius: 40px;
  font-family: arial;
  text-align: left;
  width: 680px;
  height: 893px;
}

.border-li {
  padding: 15px 0;
}

.login {
  margin-top: 240px;
}

.modal-footer .btn {
  width: 48%;
  background-size: cover;
  min-height: 120px;
}


.modal-content2 {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -10px;
  border-radius: 8px;
  margin-left: -45%;
  width: 90%;
}

.modal-content2 img {
  border-radius: 40px;
  width: 600px;
}

.close {
  background: rgb(255 255 255 / 20%);
  color: #fff;
  width: 100px;
  height: 100px;
  font-size: 60px;
  margin: 30px auto 0;
  border-radius: 100px;
}


.scrollLight {
  height: 120px;
  overflow: hidden;
  position: relative;
  //background: rgba(255,255,255,0.15);
  color: #fff;
  font-size: 28px;
  line-height: 60px;
  text-align: center;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  animation: scrollUp 60s linear infinite;
}

.scroll-item {
  height: 60px;
  white-space: nowrap;
  padding-left: 20px;
  color: red;
}

/* 向上滚动动画 */
@keyframes scrollUp {
  0% { transform: translateY(0); }
  100% { transform: translateY(-100%); }
}


</style>



// WEBPACK FOOTER //
// src/page/index.vue